import React from 'react';
import { VariantConsumer, MenuConsumer } from '../FoodMenu.context';
import { displayVariantComponentMap } from './variants';

const MenuNavigation = props => (
  <VariantConsumer>
    {({ navDisplay }) => {
      const NavigationVariant = displayVariantComponentMap.nav[navDisplay];
      return <NavigationVariant {...props} />;
    }}
  </VariantConsumer>
);

export default MenuNavigation;
